module.exports = __webpack_public_path__ + "static/img/img01.68c3606.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/page/tem001/img01.gif
// module id = kgR6
// module chunks = 0